import VideoUploadStep from './VideoUploadStep';

export default VideoUploadStep;
